import React, { useState } from 'react';
import { Toaster } from 'sonner';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../ui/tabs';
import { RuedaSyncPanel } from './RuedaSyncPanel';
import { RuedaMapeoPanel } from './RuedaMapeoPanel';
import { RuedaPendientesPanel } from './RuedaPendientesPanel';

export const RuedaImportacionTab = ({ categorias, onPublicado }) => {
  const [token, setToken] = useState(0);
  const recargar = () => setToken((t) => t + 1);
  return (
    <div className="space-y-4" data-testid="rueda-importacion-tab">
      <Toaster position="top-right" richColors />
      <div>
        <h2 className="text-lg font-semibold">Importar de la Rueda de Turismo Social Sindical</h2>
        <p className="text-sm text-gray-500">Lo importado queda en borrador hasta que lo revises y publiques. Nunca se modifican solos los prestadores ya publicados.</p>
      </div>
      <Tabs defaultValue="pendientes">
        <div className="overflow-x-auto pb-1">
          <TabsList className="inline-flex min-w-max">
            <TabsTrigger value="pendientes" data-testid="rueda-subtab-pendientes">Importaciones pendientes</TabsTrigger>
            <TabsTrigger value="sync" data-testid="rueda-subtab-sync">Sincronización y log</TabsTrigger>
            <TabsTrigger value="mapeo" data-testid="rueda-subtab-mapeo">Mapeo de categorías</TabsTrigger>
          </TabsList>
        </div>
        <TabsContent value="pendientes"><RuedaPendientesPanel categorias={categorias} recargarToken={token} onPublicado={onPublicado} /></TabsContent>
        <TabsContent value="sync"><RuedaSyncPanel onFin={recargar} /></TabsContent>
        <TabsContent value="mapeo"><RuedaMapeoPanel onSaved={recargar} /></TabsContent>
      </Tabs>
    </div>
  );
};
